export default function getCssVariableValue(variable) {
  // Check null
  if (!variable) return;

  // Check if CSS Variables are supported
  var supportsCssVariables = false;
  if (typeof window !== 'undefined' && window.CSS && typeof window.CSS.supports === 'function' && window.CSS.supports('(--fake-var: 0)')) {
    supportsCssVariables = true;
  }

  // If it's IE11 or the variable doesn't start with '--', return the raw value
  if (!supportsCssVariables || !variable.startsWith('var(--')) {
    return variable;
  }

  // Extract the CSS variable name from the 'var(--variable-name)' syntax
  var cssVariableName = variable.slice(4, -1).trim();

  // Get the value of the CSS variable
  var rootStyles = getComputedStyle(document.documentElement);
  var value = rootStyles.getPropertyValue(cssVariableName).trim();
  return value;
}